'use strict';
const DiagramActionWorkRepository = require('balus/infra/repository/actionwork/diagram');

class Service {
    constructor(action, diagramIDs) {
        this._project = action.getProject();
        this._action = action;
        this._diagramIDs = diagramIDs;
    }

    add() {
        //TODO: API を変更して ActionWork を渡すようにする
        return DiagramActionWorkRepository.find(this._project)
            .addDiagrams(this._action, this._diagramIDs);
    }
}

module.exports = Service;



// WEBPACK FOOTER //
// ./balus/app/service/actionwork/diagram/add.js